import { Link } from "react-router-dom"

import Button from "components/ui/button"

const Footer = () => {
  return (
    <footer className="tablet:pt-40 tablet:px-32 bg-grey-4 tablet:flex-row mt-auto flex flex-col-reverse items-center justify-between px-10 pb-16 pt-28 text-center">
      <span className="text-12">Powered by SAFYRE LABS, INC.</span>
      <div className="text-grey-65 tablet:m-0 mb-10 flex items-center">
        <Button asChild className="text-14" text underline>
          <Link to="/terms-conditions">Terms of Platform</Link>
        </Button>
        <div
          className="bg-grey-65 mx-8 inline-block h-14 w-px"
          role="separator"
        />
        <Button asChild className="text-14" text underline>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </Button>
      </div>
    </footer>
  )
}
export default Footer
